import { getClerkInstance } from "@clerk/clerk-expo";
import { getPremiumContext } from "@memorang/helpers/src/bundle";
import type { ExamDetails } from "@memorang/types/src/exams";
import { getShowStudyPackViews } from "./exams";
import { isWeb } from "./platform";

export const physicianRoles = [
	"orthopaedic_surgeon",
	"physician_associate",
	"resident",
	"fellow",
];
export const getDisplayName = (
	role?: string,
	firstName?: string,
	lastName?: string,
) => {
	const isPhysician = role && physicianRoles.includes(role);
	return isPhysician ? `Dr. ${lastName || ""}` : firstName || "";
};

export const getPurchasedExams = (examsList: ExamDetails[]) => {
	const purchasedExams = examsList?.filter(({ exam: { bundles } }) => {
		return bundles.find((item) => {
			const { hasAccess } = getPremiumContext(item.metadata);
			return hasAccess;
		});
	});
	return purchasedExams;
};

export const getPurchasedProducts = (examsList: ExamDetails[]) => {
	const purchasedExams = getPurchasedExams(examsList);

	const purchasedProducts = purchasedExams?.flatMap(({ exam }) =>
		exam.bundles.filter((item) => {
			return (
				getPremiumContext(item.metadata).hasAccess &&
				(item.bundle.bundleType === "PRACTICE_TEST"
					? isWeb
					: getShowStudyPackViews(exam.studyPackCollection?.[0]))
			);
		}),
	);
	return purchasedProducts;
};

export const getLogicalUserIdFromClerk = async () => {
	const user = await getClerkInstance().user;
	return user?.publicMetadata.logicalId as string;
};
